import { microChainCurrencyServer } from "..";
import { API } from "../class";
import joi from "joi";

// export const getCoinBalanceV1API = new API<
//   // REQUEST_TYPE
//   {
//     query: {
//       address: string;
//       microChainId: number;
//     };
//   },
//   // RESPONSE_TYPE
//   {
//     balance: string;
//   }
// >({
//   serverInstance: microChainCurrencyServer,
//   url: "/v1/wallets/coins/balance",
//   method: "get",
//   requestValidator: joi.object({
//     query: joi.object({
//       address: joi.string().required(),
//       microChainId: joi.number().required(),
//     }),
//   }),
// });

// export const getCurrencyBalanceRegacyAPI = new API<
//   // REQUEST_TYPE
//   {
//     params: {
//       microChainCurrencyId: number;
//     };
//     query: {
//       address: string;
//       microChainId: number;
//     };
//   },
//   // RESPONSE_TYPE
//   {
//     balance: string;
//   }
// >({
//   serverInstance: microChainCurrencyServer,
//   url: "/v1/wallets/micro-chain-currency/:microChainCurrencyId/balance",
//   method: "get",
//   requestValidator: joi.object({
//     params: joi.object({
//       microChainCurrencyId: joi.number().required(),
//     }),
//     query: joi.object({
//       address: joi.string().required(),
//       microChainId: joi.number().required(),
//     }),
//   }),
// });

export const getERC20BalanceAPI = new API<
  // REQUEST_TYPE
  {
    params: {
      microChainCurrencyId: number;
    };
    query: {
      address: string;
      microChainId: number;
    };
  },
  // RESPONSE_TYPE
  {
    balance: string;
  },
  // PARSED_RESPONSE_TYPE
  string
>({
  serverInstance: microChainCurrencyServer,
  url: "/v2/micro-chain-currency/:microChainCurrencyId/balance",
  method: "get",
  requestValidator: joi.object({
    params: joi.object({
      microChainCurrencyId: joi.number().required(),
    }),
    query: joi.object({
      address: joi.string().required(),
      microChainId: joi.number().required(),
    }),
  }),
});
